import { FETCH_UPDATE_ORDERS_REQUEST, FETCH_UPDATE_ORDERS_SUCCESS, FETCH_UPDATE_ORDERS_FAILURE } from "../../actions";
const initialState = {
    updateOrders: null,
    isLoading: false,
    error: null,
};
const orderDimensionUpdateReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_UPDATE_ORDERS_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, updateOrders: null });
        case FETCH_UPDATE_ORDERS_SUCCESS:
            return Object.assign(Object.assign({}, state), { updateOrders: action.payload, isLoading: false, error: null });
        case FETCH_UPDATE_ORDERS_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload, updateOrders: null });
        default:
            return state;
    }
};
export default orderDimensionUpdateReducer;
